<template>
  <div>
    <fieldset class="form__field-group">
      <legend class="h4">
        Velg taktype
        <question-icon @onClick="showModal = true"></question-icon>
      </legend>
      <div class="selectable-boxes-container">
        <div
          class="selectable-boxes"
          :class="{ selected: rtype.selected }"
          :key="rtype.internal_id"
          v-for="rtype in externalRoofTypes"
          @click="selectRoofType(rtype)"
        >
          <div>{{ rtype.name }}</div>
          <div v-if="rtype.description" class="selectable-boxes-secondary-text">
            {{ rtype.description }}
          </div>
          <i class="material-icons" hidden>check</i>
        </div>
      </div>
    </fieldset>

    <legend class="h4">
      Jeg vil legge integrerte paneler
    </legend>
    <p>
      Har du skifertak må du velge dette alternativet.
    </p>
    <div class="selectable-boxes-container">
      <div
        class="selectable-boxes selectable-boxes--fullwidth"
        :class="{ selected: inegratedRoofType.selected }"
        @click="selectRoofType(inegratedRoofType)"
      >
        <div>{{ inegratedRoofType.name }}</div>
        <div
          v-if="inegratedRoofType.description"
          class="selectable-boxes-secondary-text"
        >
          {{ inegratedRoofType.description }}
        </div>
        <i class="material-icons" hidden>check</i>
      </div>
    </div>

    <div
      class="modal"
      :class="{ 'is-visible': showModal }"
      id="modal1"
      @keyup.esc="showModal = false"
      @click.self="showModal = false"
      tabindex="0"
    >
      <div class="modal-dialog">
        <header class="modal-header">
          Taktype
          <button
            type="button"
            class="close-modal"
            aria-label="close modal"
            @click="showModal = false"
          >
            ✕
          </button>
        </header>
        <section class="modal-content">
          <legend class="h4">Finn din taktype</legend>
          <p>
            <i class="material-icons">info</i> Finner du ikke taket ditt under?
            Da må du mest sannsynlig erstatte eksisterende tak med integrerte
            solcellepaneler. Eksisterende tak må fjernes og er en ekstra kostnad
            utenom tilbudet fra oss.
          </p>
          <div class="selectable-boxes-container">
            <div
              class="selectable-boxes"
              :key="rtype.internal_id"
              v-for="rtype in externalRoofTypes"
              @click="
                showModal = false;
                selectRoofType(rtype);
              "
            >
              <div class="form__field--radio__card--title">
                {{ rtype.name }}
              </div>
              <img :src="rtype.imgsrc" />
              <div
                v-if="rtype.description"
                class="selectable-boxes-secondary-text"
              >
                {{ rtype.description }}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store';
import QuestionIcon from './QuestionIcon.vue';

let data = {
  open: false,
  roofTypes: [
    {
      id: 10,
      name: 'Integrerte paneler',
      internal_id: 10,
      imgsrc: 'https://solkart.no/img/easyroof.jpg',
      excelname: 'IRFTS',
      selected: false,
      integrated: true,
    },
    {
      id: 3,
      internal_id: 0,
      name: 'Dobbelkrum takstein',
      imgsrc: store.state.imagePath + '/img/tak/dobbelkrum.jpg',
      excelname: 'Dobbelkrum',
      selected: false,
    },
    {
      id: 4,
      internal_id: 1,
      name: 'Enkelkrum takstein',
      imgsrc: store.state.imagePath + '/img/tak/enkelkrum.jpg',
      excelname: 'Enkelkrum',
      selected: false,
    },
    {
      id: 7,
      name: 'Glatt takpanne (Decra)',
      internal_id: 2,
      imgsrc: store.state.imagePath + '/img/tak/takpanne.jpg',
      excelname: 'Trapes',
      selected: false,
    },
    {
      id: 8,
      name: 'Ru takpanne (Decra)',
      internal_id: 3,
      imgsrc: store.state.imagePath + '/img/tak/decra.jpg',
      excelname: 'Decra',
      selected: false,
    },
    {
      id: 1,
      name: 'Shingel',
      internal_id: 4,
      imgsrc: store.state.imagePath + '/img/tak/shingel.jpg',
      excelname: 'Pappshingel',
      selected: false,
    },
    {
      id: 2,
      name: 'Takpapp',
      internal_id: 5,
      imgsrc: store.state.imagePath + '/img/tak/takpapp.jpg',
      excelname: 'Pappshingel',
      selected: false,
    },
    {
      id: 9,
      name: 'Folie (Protan, Sarnafil)',
      internal_id: 6,
      imgsrc: store.state.imagePath + '/img/tak/folie.jpg',
      excelname: 'Pappshingel',
      selected: false,
    },
    {
      id: 6,
      name: 'Bølgeblikk stålplate',
      internal_id: 7,
      imgsrc: store.state.imagePath + '/img/tak/bolgeblikk.jpg',
      excelname: 'Trapes',
      selected: false,
    },
    {
      id: 5,
      name: 'Trapes stålplate',
      internal_id: 8,
      imgsrc: store.state.imagePath + '/img/tak/trapes.jpg',
      excelname: 'Trapes',
      selected: false,
    },
  ],
  showModal: false,
};

export default {
  name: 'RoofType',
  components: {
    QuestionIcon,
  },
  data() {
    return data;
  },
  computed: {
    selected() {
      return store.state.roofType;
    },
    externalRoofTypes() {
      return this.roofTypes.filter(roofType => !roofType.integrated);
    },
    inegratedRoofType() {
      return this.roofTypes.find(roofType => roofType.integrated);
    },
  },
  created() {
    if (!store.state.roofType) {
      this.roofTypes[1].selected = true;
      store.commit('setRoofType', { roofType: this.roofTypes[1] });
    } else if (this.selected) {
      this.roofTypes.find(
        roofType => this.selected.id === roofType.id
      ).selected = true;
    }
  },
  methods: {
    selectRoofType(roofType) {
      this.roofTypes.forEach(element => {
        element.selected = false;
      });

      roofType.selected = true;
      store.commit('setRoofType', { roofType });
      this.open = false;
    },
  },
};
</script>

<style scoped src="../assets/css/selectable-boxes.css"></style>
